export default __webpack_public_path__ + "static/media/area-chart.773632bd.svg";